import api from "@/api";

const buildQuery = (filters = {}) => {
    const params = [];
    if (filters.from) params.push(`from=${encodeURIComponent(filters.from)}`);
    if (filters.to) params.push(`to=${encodeURIComponent(filters.to)}`);
    if (Array.isArray(filters.categoryIds) && filters.categoryIds.length) {
        params.push(`categoryIds=${filters.categoryIds.join(',')}`);
    }
    if (Array.isArray(filters.thirdPartyIds) && filters.thirdPartyIds.length) {
        params.push(`thirdPartyIds=${filters.thirdPartyIds.join(',')}`);
    }
    if (Array.isArray(filters.cajaIds) && filters.cajaIds.length) {
        params.push(`cajaIds=${filters.cajaIds.join(',')}`);
    }
    if (Array.isArray(filters.years) && filters.years.length) {
        params.push(`years=${filters.years.join(',')}`);
    }
    if (filters.granularity) params.push(`granularity=${filters.granularity}`);
    if (filters.metric) params.push(`metric=${filters.metric}`);
    if (filters.limit) params.push(`limit=${filters.limit}`);
    return params.length ? `?${params.join('&')}` : '';
};

const isoDate = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

export function buildPresetFilters(mode, now = new Date()) {
    const today = isoDate(now);
    if (mode === 'month') {
        const first = new Date(now.getFullYear(), now.getMonth(), 1);
        return { from: isoDate(first), to: today, granularity: 'day' };
    }
    if (mode === 'year') {
        const first = new Date(now.getFullYear(), 0, 1);
        return { from: isoDate(first), to: today, granularity: 'month' };
    }
    if (mode === 'comparison') {
        return { granularity: 'month' };
    }
    const first = new Date(now.getFullYear(), 0, 1);
    return { from: isoDate(first), to: today, granularity: 'month' };
}

export async function getSummary(filters = {}) {
    try {
        const res = await api.get(`/dashboard/summary${buildQuery(filters)}`);
        return res.data;
    } catch (err) {
        console.error("Error fetching dashboard summary:", err);
        return { totals: { ingresos: 0, gastos: 0, balance: 0 }, series: [], filters };
    }
}

export async function getByCategory(filters = {}) {
    try {
        const res = await api.get(`/dashboard/by-category${buildQuery(filters)}`);
        return res.data;
    } catch (err) {
        console.error("Error fetching dashboard by-category:", err);
        return { ingresos: [], gastos: [] };
    }
}

export async function getByThirdParty(filters = {}) {
    try {
        const res = await api.get(`/dashboard/by-third-party${buildQuery(filters)}`);
        return res.data;
    } catch (err) {
        console.error("Error fetching dashboard by-third-party:", err);
        return { ingresos: [], gastos: [] };
    }
}

export async function getYearComparison(filters = {}) {
    try {
        const res = await api.get(`/dashboard/year-comparison${buildQuery(filters)}`);
        return res.data;
    } catch (err) {
        console.error("Error fetching dashboard year-comparison:", err);
        return { metric: filters.metric || 'ingresos', years: filters.years || [], months: [], series: [] };
    }
}

export async function getByCaja(filters = {}) {
    try {
        const res = await api.get(`/dashboard/by-caja${buildQuery(filters)}`);
        return res.data;
    } catch (err) {
        console.error("Error fetching dashboard by-caja:", err);
        return { cajas: [] };
    }
}
